import { ClipboardList } from 'lucide-react';
import { palette } from '../shared/theme';

interface FormScopePillProps {
  name: string;
}

export function FormScopePill({ name }: FormScopePillProps) {
  return (
    <span
      className="inline-flex max-w-full items-center gap-1 truncate rounded-full border px-2 py-0.5 text-xs font-medium"
      style={{
        color: palette.text,
        borderColor: palette.yellow,
        backgroundColor: `${palette.yellow}26`,
      }}
    >
      <ClipboardList
        className="h-3 w-3 flex-shrink-0"
        style={{ color: palette.yellow }}
        aria-hidden
      />
      <span className="truncate">{name}</span>
    </span>
  );
}
